import { Action, createReducer, on } from '@ngrx/store';

import { HelpFaqActions } from '../actions';
import { HelpFaqState } from '../state';

const reducer = createReducer(
  HelpFaqState.initialState,
  on(HelpFaqActions.LoadFaqs, (state: HelpFaqState.State) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(HelpFaqActions.LoadFaqsSuccess, (state: HelpFaqState.State, { payload }) => ({
    ...state,
    faqData: payload.faqData,
    isLoading: false,
    error: null,
  })),
  on(HelpFaqActions.LoadFaqsFailure, (state: HelpFaqState.State, { payload }) => ({
    ...state,
    isLoading: false,
    error: payload.error,
  }))
);

export function helpFaqReducer(state: HelpFaqState.State | undefined, action: Action) {
  return reducer(state, action);
}
